var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inventory-legend",class:{ 'inventory-legend--outlined': _vm.outlined }},[_c('div',{staticClass:"inventory-legend__dot",style:(`--dot-color: ${_vm.setBackgroundColor()}`)}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }